<template>
    <div>
        <!-- All Transactions ============================================= -->
        <div class="bg-light shadow-sm rounded py-4 mb-4">
            <div class="mb-4 px-4">
                <h3 class="text-4 font-weight-700 d-flex align-items-center mb-0">
                    Payouts
                </h3>
            </div>
            <!-- Title =============================== -->
            <div class="transaction-title py-2 px-4">
                <div class="row">
                    <div class="col-2 d-none d-sm-block  col-sm-1 text-center"><span class="">Date</span></div>
                    <div class="col col-sm-3 d-none d-sm-block ">Reference</div>
                    <div class="col col-sm-4 d-none d-sm-block">Bank\Wallet</div>
                    <div class="col col-sm-2">Status</div>
                    <div class="col-auto col-sm-2 text-center">Amount</div>
                </div>
            </div>
            <!-- Title End -->

            <!-- Transaction List
            =============================== -->
            <div class="transaction-list">
                <div v-for="row in payouts.content.data" :key="row.id" class="transaction-item d-block px-4 py-3">
                    <div class="row align-items-center flex-row">
                        <div class="col-2 col-sm-1 d-none d-sm-block  text-center row-text">
                            <FormattedDate :dateString="row.created_at" />
                        </div>
                        <div class="col col-sm-3 ">
                            <span class="d-block row-text">Ref#{{ row.payout_reference }}</span>
                            <small class="d-block">Type:{{ row.type }}</small>
                        </div>
                        <div class="col col-sm-4 d-none d-sm-block ">
                            <span v-if="row.type === 'WALLET-TRANSFER'">
                                Corporate {{row.currency}} Wallet
                            </span>
                            <span v-else v-for="i in row.corporate.banks.filter(bank => bank.currency === row.currency)" :key="i.id">
                                {{ i.bank_name }} <strong>•••• {{ i.account_number.toString().slice(-4) }}</strong>
                            </span>
                        </div>

                        <div class="col col-sm-2 d-flex flex-row d-none d-sm-block ">
                            <div class="bg-light-4 p-1 text-center rounded-pill">
                                <span v-if="row.status.includes('IN-TRANSIT')" class="text-info ">
                                <i class="fas fa-spinner"></i>
                            </span>
                                <span v-if="row.status.includes('PAID')" class="text-success">
                                <i class="fas fa-check-circle"></i>
                            </span>
                                <span class="row-text text-1 ml-2" >{{ row.status }}</span>
                            </div>
                        </div>
                        <div class="col-3 col-sm-2 text-right row-text">
                                <span >
                                   {{ row.currency === 'USD' ? 'USD' : 'ZWG' }} {{ money(row.amount) }}
                                </span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Transaction List End -->

            <!-- Pagination ============================================= -->
            <div class="d-flex align-items-center justify-content-between px-4">
                <span class="text-black-50">
                    Showing {{ payouts.content.data.length }} of {{ payouts.content.total }} Records
                </span>
                <ul class="pagination justify-content-center mt-4 mb-0">
                    <li class="page-item disabled">
                        <a class="page-link" href="#" tabindex="-1">
                            <i class="fas fa-angle-left"></i>
                        </a>
                    </li>
                    <li class="page-item active">
                        <a @click="payouts.append()"
                           v-if="payouts.content.total !== payouts.content.to && payouts.content.data.length > 0"
                           class="page-link" href="#">
                            Load More <span class="sr-only">(current)</span>
                        </a>
                    </li>
                    <li class="page-item d-flex align-content-center flex-wrap text-muted text-5 mx-1">
                        <span>...</span>
                    </li>
                    <li class="page-item disabled">
                        <a class="page-link" href="#" tabindex="-1">
                            <i class="fas fa-angle-right"></i>
                        </a>
                    </li>
                </ul>
            </div>
            <!-- Paginations end -->
        </div>
    </div>
</template>

<script>
import FormattedDate from "../../../core/FormattedDate.vue";
import {money} from "../../../../core/forms/money";
import Form from "../../../../core/forms/form";
import Data from "../../../../core/data/Data";

export default {
    name: "Payouts",
    components: {FormattedDate},
    props: ['wallet'],
    mixins: [money],
    data(){
        return {
            payouts :  new Data({
                url : `/business/wallets/${this.$route.params.id}/payouts`,
                prefix : "list"
            }),
            message:'',
            tempEndDate: '',
            form: new Form({
                startDate: '',
                endDate: ''
            }),
        };
    },
    mounted() {
        this.payouts.fetch()
    }
}
</script>

<style scoped>
.row-text{
    color: #252c65;
}
</style>
